import { SvgIcon, SvgIconProps } from "@mui/material";

import { ReactComponent as svgFile } from "./assets/animal_shelter.svg";

export const AnimalShelterIcon = (props: SvgIconProps) => {
  return <SvgIcon {...props} component={svgFile} aria-hidden="true" role="img"/>;
};
